import { EmailSettings } from 'common/modules/emails/types';
import { getTypedKeys } from 'common/utils/objects';
import { CUSTOMER_FACING_EMAILS } from 'common/modules/emails/constants';

export const getDefaultEmailSettings = () =>
	getTypedKeys(CUSTOMER_FACING_EMAILS).reduce(
		(acc, val) => ({ ...acc, [val]: { enabled: true } }),
		{} as EmailSettings,
	);
